module.exports = __webpack_public_path__ + "img/logo-26-1.3075e22f.png";